import { Position } from '@xyflow/react';

/** Handle sides for a node: a TB canvas flows top→bottom, LR left→right. */
export function getHandlePositions(layoutDirection?: string): {
  source: Position;
  target: Position;
} {
  return layoutDirection === 'TB'
    ? { source: Position.Bottom, target: Position.Top }
    : { source: Position.Right, target: Position.Left };
}

/** The flow a node belongs to: its item's origin node, else the flow id the canvas passed down. */
export function getNodeFlowId(data: any) {
  return data?.item?.origin_node_id ?? data?.flowId;
}
